import * as React from 'react';
import {
  CreateButton,
  EditButton,
  Filter,
  List,
  TextField,
  TextInput,
} from 'react-admin';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { SubListContent } from '../../../components/sub-list-content';
import { CustomListTopToolbar } from '../../../components/custom-list-top-toolbar';
import { OrderButtons } from '../../../components/order-buttons';
import BulkDeleteUndoableButton from '../../../components/bulk-delete-undoable-button';

const useStyles = makeStyles({
  root: {
    marginTop: '1rem',
  },
});

const UserFilter = (props: any) => {
  return (
    <Box px={2}>
      <Filter {...props}>
        <TextInput label="Name" source="name" alwaysOn />
      </Filter>
    </Box>
  );
};

const CreateInquiryTypeButton = (props: any) => {
  return (
    <CreateButton
      component={Link}
      to={{
        pathname: '/inquiry-type/create',
        state: { record: { companyId: props.companyId } },
      }}
    >
      Add New InquiryType
    </CreateButton>
  );
};

const ListEmpty = (props: any) => (
  <Box textAlign="center" m={1}>
    <Typography>
      No inquiry types have been created for this company.
    </Typography>
    <CreateInquiryTypeButton {...props} />
  </Box>
);

export const CompanyInquiryTypeList = (props: any) => {
  const classes = useStyles();

  return (
    <List
      {...props}
      basePath="/inquiry-type"
      resource="inquiry-type"
      hasCreate={true}
      filter={{ 'companyId||$eq': props.id }}
      className={classes.root}
      title={<span />}
      actions={
        <CustomListTopToolbar
          createButton={<CreateInquiryTypeButton companyId={props.id} />}
        />
      }
      filters={<UserFilter />}
      sort={{ field: 'sortPriority', order: 'ASC' }}
      empty={<ListEmpty companyId={props.id} />}
      bulkActionButtons={<BulkDeleteUndoableButton />}
    >
      <SubListContent rowClick="edit">
        <TextField source="name" />
        <TextField source="recipientEmail" />
        <OrderButtons source="sortPriority" />
        <EditButton label="" textAlign="right" />
      </SubListContent>
    </List>
  );
};
